import { render, staticRenderFns } from "./GameRank.vue?vue&type=template&id=41d0eeb8&"
import script from "./GameRank.vue?vue&type=script&lang=ts&"
export * from "./GameRank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports